import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useAnalytics } from "../contexts/analytics/hooks";
import { useHospitalData } from "../contexts/HospitalDataProvider";
import { useSnackbar } from "../contexts/SnackbarContext";
import { backendService } from "../services/backend.service";
import type { PublishSelfSchedulingRequest } from "../utils/models";

export const useSelfSchedulingPublish = () => {
	const { showSnackbar } = useSnackbar();
	const { chosenDepartment, showErrorSnackbar } = useHospitalData();
	const { track } = useAnalytics();
	const { t } = useTranslation();

	return useMutation({
		mutationFn: async (request: { preferences: Array<{ startDate: string; endDate: string }> }) => {
			track("self_scheduling_publish_start");
			const body: PublishSelfSchedulingRequest = { ...request, departmentId: chosenDepartment.department_id };
			const response = await backendService.publishSelfScheduling(body);
			track("self_scheduling_publish_success");
			return response.data;
		},
		onSuccess: () => showSnackbar(t("preferences.published.successfully"), "success"),
		onError: (error) => showErrorSnackbar(t("failed.to.publish.preferences"), {}, error),
	});
};
